/**
 * Cuentas bancarias
 *
 */
import React from 'react'
import Api from '../../../Api'
import { Panel } from '../../../components'
import { Skeleton, Icon, Popconfirm, Badge, Typography } from 'antd'
import Exception from '../../../Exception'
import { connect } from 'react-redux'
import CuentaBancariaModal from './CuentaBancaria'

const CuentaBancaria = (props) => {
  const [hovered, setHovered] = React.useState(false)
  const [overDelete, setOverDelete] = React.useState(false)

  return (
    <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} onClick={props.onClick}>
      <Panel hoverable style={{ cursor: 'pointer', width: 300, maxWidth: 300, marginBottom: 15 }}>
        <div  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <label>NOMBRE</label>
            <h4>{props.sNombreCuenta}</h4>
          </div>
          <Badge status={props.iDisponible ? 'success' : 'warning'} />
        </div>
        <h5>{props.banco.sSATNombre}</h5>

        <div style={{ height: 20 }} />

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ marginRight: 12 }}>
            <label>MONEDA</label>
            <h5>{props.moneda.sNombre}</h5>
          </div>

          <div style={{ marginRight: 12 }}>
            <label>CUENTA</label>
            <h5>{props.sCuenta}</h5>
          </div>

          <div style={{ maxWidth: 110 }}>
            <label>CLABE</label>
            <Typography.Paragraph ellipsis style={{ marginBottom: 5, fontWeight: 500, fontSize: 12, color: props.theme.colors.text }}>
              {props.sClaveBan}
            </Typography.Paragraph>
          </div>
        </div>

        {props.readOnly ?
          null :

          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', paddingTop: 10 }}>
            <div onClick={(e) => e.stopPropagation()}>
              <Popconfirm title='Eliminar cuenta' onConfirm={() => props.onRemove && props.onRemove()}>
                <Icon
                  type='delete'
                  style={{
                    padding: 7,
                    color: hovered ? (overDelete ? props.theme.colors.error : props.theme.colors.icon) : props.theme.colors.panel,
                    fontSize: 15,
                    transition: 'color 0.25s'
                  }}
                  onMouseEnter={() => setOverDelete(true)} onMouseLeave={() => setOverDelete(false)}
                />
              </Popconfirm>
            </div>
          </div>
        }
      </Panel>
    </div>
  )
}

class CuentasBancarias extends React.Component {
  /**
   * constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
    }
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.fetch()
  }

  /**
   * fetch
   */
  fetch = () => {
    Api.query({
      model: 'ComProveedorBanco',
      include: [
        { as: 'banco', attributes: ['sSATNombre'] },
        { as: 'moneda', attributes: ['sNombre'] },
      ],
      where: {
        iId_Prov: Api.getProviderId(),
        iActivo: true,
      }
    })
    .then(response => {
      this.setState({
        loading: false,
        data: response.data,
      })
    })
    .catch(error => {
      this.setState({ loading: false })
      Exception.load(error).show()
    })
  }

  /**
   * Eliminar cuenta
   *
   */
  remove = (id) => {
    Api.put(`/com/proveedores/cuentas/${id}`, { iActivo: false })
      .then(() => {
        this.setState({
          loading: false,
          data: this.state.data.filter(item => item.iId !== id)
        })
      })
      .catch(error => {
        this.setState({ loading: false })
        Exception.load(error).show()
      })
  }

  /**
   * render
   */
  render() {
    return (
      <Skeleton loading={this.state.loading}>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
          {this.state.data.map(item =>
            <div key={item.iId.toString()} style={{ marginRight: 20 }}>
              <CuentaBancaria
                {...item}
                readOnly={this.props.readOnly}
                theme={this.props.theme}
                onRemove={this.props.readOnly ?
                  undefined :
                  () => this.remove(item.iId)
                }
                onClick={this.props.readOnly ?
                  undefined :
                  () => this.cuentaBancaria.load(item.iId)
                }
              />
            </div>
          ).concat(this.props.readOnly ?
            [] :
            [
              <div
                key='add'
                onClick={this.props.readOnly ?
                  undefined :
                  () => this.cuentaBancaria.load(-2)
                }
                style={{
                  maxWidth: 250,
                  cursor: 'pointer',
                  display: 'flex'
                }}>
                <Panel styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 15 }}>
                  <Icon type='plus' style={{ color: this.props.theme.colors.icon, fontSize: 35 }} />
                </Panel>
              </div>
            ])
          }
        </div>

        <CuentaBancariaModal
          ref={ref => this.cuentaBancaria = ref}
          onSaved={() => this.fetch()}
        />
      </Skeleton>
    )
  }
}

export default connect(
  state => ({ theme: state.theme.values })
)(CuentasBancarias)
